export const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
export const passwordRegex = /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).{8,40}/;
export const nameRegex = /^([A-Za-zÀ-ÖØ-öø-ÿ0-9]+\s?)*$/;
export const usernameRegex = /^\w*$/;
export const italianVat = /^((IT)?[0-9]{11})$/;
